export default {
    data: () => ({
        btnLoading: false,
        server_errors: {
            title: '',
            receiver_name: '',
            phone: '',
            address: '',
            postal_code: '',
            transport_type: '',
            address_country: '',
            address_district: '',
        },
        value: {
            title: '',
            receiver_name: '',
            phone: '',
            address: '',
            postal_code: '',
            transport_type: 'normal',
            address_country: 'zh',
            address_district: '',
        },
        transportTypes: [
            { id: 'normal', name: 'ປົກກະຕິ ( Normal )' },
            { id: 'air_freight', name: 'ທາງຍົນ ( Air Freight )' },
            { id: 'railway', name: 'ທາງລົດໄຟ ( Railway )' },
        ],
        addressCountries: [
            { id: 'zh', name: 'ຈີນ ( ZH )' },
            { id: 'th', name: 'ໄທ ( TH )' },
        ],
    }),
    methods: {
        ValidateForm() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.SaveItem();
                }
            });
        },
        SaveItem() {
            this.btnLoading = true;
            const payload = {
                title: this.value.title || null,
                receiver_name: this.value.receiver_name,
                phone: this.value.phone,
                address: this.value.address,
                postal_code: this.value.postal_code || null,
                transport_type: this.value.transport_type,
                address_country: this.value.address_country,
                address_district: this.value.address_district,
            };
            this.$http.post('shipping-address', payload).then((res) => {
                if (res.data && res.data.error === false) {
                    setTimeout(() => {
                        this.btnLoading = false;
                        this.$emit('close');
                        this.$emit('success');
                        this.$notification.OpenNotification_AddItem_OnSuccess('top-right', 'dark', 3000);
                    }, 300);
                } else {
                    this.btnLoading = false;
                    this.$notification.OpenNotification_Error_Server('top-right', 'danger', 3000);
                }
            }).catch((error) => {
                this.btnLoading = false;
                if (error.response && error.response.status === 422) {
                    const obj = error.response.data.errors || {};
                    for (const [key, value] of Object.entries(obj)) {
                        this.server_errors[key] = value[0];
                    }
                } else {
                    this.$notification.OpenNotification_Error_Server('top-right', 'danger', 3000);
                }
            });
        },
    },
    watch: {
        'value.title': function () { this.server_errors.title = ''; },
        'value.receiver_name': function () { this.server_errors.receiver_name = ''; },
        'value.phone': function () { this.server_errors.phone = ''; },
        'value.address': function () { this.server_errors.address = ''; },
        'value.postal_code': function () { this.server_errors.postal_code = ''; },
        'value.transport_type': function () { this.server_errors.transport_type = ''; },
        'value.address_country': function () { this.server_errors.address_country = ''; },
        'value.address_district': function () { this.server_errors.address_district = ''; },
    },
};
